import React from "react";

/**
 * Leads-grid cell for the "Referred By" column.
 * When the lead carries a referrer (buyer referral), shows a "Referral" pill + the referrer's name.
 * Otherwise renders a muted dash so the column reads cleanly for non-referral leads.
 */
const ReferralTagRenderer = ({ data }) => {
    const account = data?.user_account;
    const referrer = account?.referrer;
    const hasReferral = Boolean(account?.referrerUserId || referrer);

    if (!hasReferral) {
        return <span className="text-slate-300">—</span>;
    }

    const name = referrer
        ? `${referrer.firstName || ""} ${referrer.lastName || ""}`.trim() ||
          referrer.emailId ||
          referrer.mobileNoWa ||
          `User #${account?.referrerUserId}`
        : `User #${account?.referrerUserId}`;

    return (
        <div className="flex items-center gap-2">
            <span className="inline-flex items-center rounded-full bg-flamingo-100 px-2 py-0.5 text-xs font-medium text-flamingo-700 border border-flamingo-200">
                Referral
            </span>
            <span className="truncate text-sm text-slate-700" title={name}>
                {name}
            </span>
        </div>
    );
};

export default ReferralTagRenderer;
